module.exports = __webpack_public_path__ + "media/images/gateway/coingate-db7ceb0490abb4a81e6710d5566523bf.jpg";